import { render, staticRenderFns } from "./AttachmentsColumn.vue?vue&type=template&id=9e0b24bc&scoped=true"
import script from "./AttachmentsColumn.vue?vue&type=script&lang=js"
export * from "./AttachmentsColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e0b24bc",
  null
  
)

export default component.exports